import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';

// SkeletonLoader component to show a loading state
const SkeletonLoader = () => {
  return (
    <div className="col-lg-4 col-sm-6">
      <div className="listing_Box">
        <div className="skeleton-image"></div>
        <div className="lb_conatent">
          <div className="skeleton-title"></div>
        </div>
      </div>
    </div>
  );
};

function BlogList({ posts }: any) {
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
 
    const fetchPosts = () => {
      setTimeout(() => {
        setLoading(false);
      }, 1000); 
    };

    fetchPosts();
  }, []);

  // Render SkeletonLoader component while posts are loading
  if (loading) {
    return (
      <>
        <SkeletonLoader />
        <SkeletonLoader />
        <SkeletonLoader />
      </>
    );
  }

  // Render posts when loading is complete and posts are available
  return (
    <>
      {posts  ?   (
        posts.map((post: any, index: number) => (
          <div key={index} className="col-lg-4 col-sm-6" data-aos="fade" data-aos-delay="100">
            <div className="listing_Box">
              <Link href={`/blogs/${post?.slug}`} className="lb_img">
                <Image src={post?.featuredImage?.node?.sourceUrl} width={546} height={280} alt="blog"  />
              </Link>
              <div className="lb_conatent">
                <Link href={`/blogs/${post?.slug}`}>
                  <h2 className="f24 fw-800">{post?.title}</h2>
                </Link>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p>No results found.</p>
      )}
    </>
  );
}

export default BlogList;
